import { BaseEntity, DefaultResponseWithData } from "./system";

export enum TemplateType {
  All = 0,
  Message = 1,
  Email = 2,
}

export interface ITemplateEditorMergeTag {
  tag: string;
  label: string;
}

export interface ITemplateEditorChildTemplate {
  id: string;
  type: TemplateType;
  title: string;
  body: string;
  parentTemplateId: string;
}

export interface ITemplateEditorParentTemplate {
  id: string;
  type: TemplateType;
  title: string;
  body: string;
  description?: string | null;
  childTemplate: ITemplateEditorChildTemplate | null;
  mergeTags: ITemplateEditorMergeTag[];
}

export interface ITemplateEditorResponse extends DefaultResponseWithData<ITemplateEditorParentTemplate[]> { }

export interface ICreateUpdateTemplateRequest {
  type: TemplateType;
  title: string;
  body: string;
  parentTemplateId?: string | null;
}

export interface ITemplateEntity extends BaseEntity {
  type: TemplateType;
  title: string;
  body: string;
  parentTemplateId?: string | null;
  isCustom: boolean;
  customerId?: string | null;
}
